export default "__VITE_ASSET__DShA7Ys7__"